import { connect } from "react-redux";
import { Form } from "formik";
import moment from "moment-timezone";
import React, { Component } from "react";

import {
  BS_INITIAL_VALUES,
  BS_SCHEMA,
  P_INITIAL_VALUES,
  P_SCHEMA,
} from "@/containers/Dashboard/Providers/PatientProfileView/schema/newNoteFormSchema";
import {
  BS_VALIDATION_SCHEMA,
  P_VALIDATION_SCHEMA,
} from "@/containers/Dashboard/Providers/PatientProfileView/schema/newNoteValidation";
import Button from "@/components/UI/Button";
import {
  createCommonNoteData,
  deleteNote,
  extractSessionDateData,
  getICD10Dataset,
  getNoteCard,
  getNoteFields,
  pickNoteDate,
  setBehavioralNoteData,
  setPrescriberNoteData,
} from "@/features/notes/(legacy)/components/ProgressNotes";
import { DeleteNote } from "@/features/notes/(v2)/components/DeleteNote";
import { getCompletedCalls } from "@/features/notes/helpers/completed-calls";
import images from "@/utils/images";
import { isAuthorized } from "@/utils/authToken";
import { providerRequests } from "@/api/(requests)/provider";
import { sharedRequests } from "@/api/(requests)/shared";
import { showLoader } from "@/redux/actions/loader";
import store from "@/redux/store";
import { timeSlotArray } from "@/components/Provider/ScheduleAvailability/constants";
import { transformTimeSlotArray } from "@/components/Provider/ScheduleAvailability/ScheduleEvent";

export class ViewDraftNote extends Component {
  constructor(props) {
    super(props);
    this.state = {
      behavioral: isAuthorized("provider:behavioral"),
      completedCalls: [],
      dateContext: moment(),
      ICD10: [],
      id: this.props.match.params.noteId,
      isSigned: false,
      note: null,
      patientId: this.props.match.params.patientId,
      patientName: "",
      prescribe: isAuthorized("provider:prescribe"),
      sessionFrom: "",
      sessionTo: "",
      showDatePicker: false,
      showDeleteNote: false,
      timeSlotOptions: transformTimeSlotArray([...timeSlotArray]),
    };
  }

  componentDidMount = async () => {
    try {
      getICD10Dataset(this);
      let urlParams = { patientId: this.state.patientId };
      const searchParams = { note_id: this.state.id };
      const response = await sharedRequests.fetch_patient_progress_notes({
        searchParams,
        urlParams,
      });
      let note = null;
      let newState = {};

      if (response) {
        note = response;
        newState["note"] = note;
        newState["title"] = note.title;
        newState["isSigned"] = !!note.signature;
      }
      const completedCalls = await getCompletedCalls(urlParams);

      if (note && note.call_id) {
        const call = completedCalls.find((el) => el["value"] === note.call_id);

        newState = { ...newState, ...extractSessionDateData(call.display, this, false) };
      }
      newState["completedCalls"] = completedCalls;
      // eslint-disable-next-line react/no-did-mount-set-state
      this.setState(newState);
    } catch (e) {
      console.log(e);
    }
    document.addEventListener("change", this.formChangeHandler, {
      capture: true,
    });
  };

  getPickedDate = (dateString) => {
    pickNoteDate(this, dateString);
  };

  formChangeHandler = (e) => {
    if (e.target.name === "session_from") {
      this.setState({ sessionFrom: moment(e.target.value, "hh:mm a").format("HH:mm") });
    } else if (e.target.name === "session_to") {
      this.setState({ sessionTo: moment(e.target.value, "hh:mm a").format("HH:mm") });
    }
  };

  renderForm = (formikProps) => {
    this.noteData = formikProps.values;
    let schema;

    if (this.state.behavioral) {
      schema = BS_SCHEMA;
    } else {
      schema = P_SCHEMA;
    }
    const callIdIndex = schema.findIndex((el) => el["name"] === "call_id");

    if (callIdIndex) {
      schema[callIdIndex].elementConfig.options = this.state.completedCalls;
    }

    return (
      <Form>
        <div className="mx-auto px-0">
          <div className="container">{getNoteFields(formikProps, schema, this, true)}</div>
        </div>

        <div className="d-flex justify-content-between ml-4 mr-4 tw:justify-center">
          <Button
            className="d-none d-sm-inline Btn Btn--otl-err Btn-sm mr-3"
            onClick={() => this.setState({ showDeleteNote: true })}
            type="button"
          >
            <img alt="" className="mr-1" src={images("./icons/delete-trash.svg")} /> Delete
          </Button>

          <div className="d-flex tw:justify-center">
            <Button
              className="Btn Btn--otl-pri Btn-sm mr-3"
              onClick={() => this.submitHandler(this.noteData, {}, true)}
              type="button"
            >
              Cancel
            </Button>

            <Button className="Btn Btn--pri Btn-sm" type="submit">
              Add Note
            </Button>
          </div>
        </div>
      </Form>
    );
  };

  submitHandler = async (formData, _actions, draft) => {
    store.dispatch(showLoader());
    let data = await createCommonNoteData(this, formData, this.state.title, this.props.profile);

    if (this.state.behavioral) {
      setBehavioralNoteData(this, formData, this.state.title, data);
    } else {
      setPrescriberNoteData(this, formData, this.state.title, data);
    }

    data.id = this.state.id;
    let urlParams = { patientId: this.state.patientId };

    data.note_state = "complete";

    if (draft) {
      data.note_state = "draft";
    }

    providerRequests
      .put_progress_note({ data, urlParams })
      .then(() => {
        this.props.history.go(-1);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  setBehavioralSpecialistNote = (note) => {
    let vals = { ...BS_INITIAL_VALUES };

    vals.title = note.title;
    vals.session_date = note.session_date;
    vals.session_from = note.session_from;
    vals.session_to = note.session_to;
    vals.patient_report = note.patient_report;
    vals.patient_task = note.patient_task;
    vals.interventions = note.interventions;
    vals.intervention_reaction = note.intervention_reaction;
    vals.call_id = note.call_id ? note.call_id : "";
    vals.isSigned = !!note.signature;
    vals.ICD_axis_1 = note.ICD_10_axis_1_diagnosis;
    vals.ICD_axis_2 = note.ICD_10_axis_2_diagnosis;

    return vals;
  };

  setPrescriberNote = (note) => {
    let vals = { ...P_INITIAL_VALUES };

    vals.title = note.title;
    vals.session_date = note.session_date;
    vals.session_from = note.session_from;
    vals.session_to = note.session_to;
    vals.patient_reported = note.patient_reported;
    vals.prescriber_interventions = note.prescriber_interventions;
    vals.intervention_reaction = note.intervention_reaction;
    vals.call_id = note.call_id ? note.call_id : "";
    vals.isSigned = !!note.signature;
    vals.ICD_axis_1 = note.ICD_10_axis_1_diagnosis;
    vals.ICD_axis_2 = note.ICD_10_axis_2_diagnosis;

    return vals;
  };

  signatureClickHandler = async (e, formikProps) => {
    const isSigned = !this.state.isSigned;

    await formikProps.setFieldValue("isSigned", isSigned);
    formikProps.setFieldTouched("isSigned");
    this.setState({ isSigned: isSigned });
  };

  renderTitle = () => {
    return (
      <div className="ml-0 ml-lg-3">
        <b>{this.state.note.title}</b>
      </div>
    );
  };

  render() {
    let vals;
    let validation;

    if (this.state.note && this.state.note.provider_type.includes("BEHAVIORAL")) {
      vals = this.setBehavioralSpecialistNote(this.state.note);
    } else if (this.state.note && this.state.note.provider_type === "PRESCRIBE") {
      vals = this.setPrescriberNote(this.state.note);
    }

    if (this.state.behavioral) {
      validation = BS_VALIDATION_SCHEMA;
    } else {
      validation = P_VALIDATION_SCHEMA;
    }

    return (
      <div>
        {this.state.showDeleteNote && (
          <DeleteNote
            clickHandler={() => deleteNote(this, this.state.patientId, this.state.note.id)}
            close={() => this.setState({ showDeleteNote: false })}
          />
        )}
        {this.state.note && getNoteCard(vals, validation, this)}
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    profile: state.auth.profile,
  };
};

export default connect(mapStateToProps)(ViewDraftNote);
